import { useTheme } from "~/components/theme-provider";
import { ClerkProvider } from "@clerk/clerk-react";
import { dark } from "@clerk/themes";

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const SIGN_IN_URL = import.meta.env.VITE_CLERK_SIGN_IN_URL;
const SIGN_UP_URL = import.meta.env.VITE_CLERK_SIGN_UP_URL;
const SIGN_UP_FORCE_REDIRECT_URL = import.meta.env
  .VITE_CLERK_SIGN_UP_FORCE_REDIRECT_URL;

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const { appliedTheme } = useTheme();
  const clerkTheme = appliedTheme === "dark" ? dark : undefined;

  return (
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      signInUrl={SIGN_IN_URL}
      signUpUrl={SIGN_UP_URL}
      signUpForceRedirectUrl={SIGN_UP_FORCE_REDIRECT_URL}
      signInForceRedirectUrl={"/"}
      appearance={{ baseTheme: clerkTheme }}
    >
      {children}
    </ClerkProvider>
  );
}
